'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialInstagram = function TiSocialInstagram(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 5h-20c-2.8 0-5 2.2-5 5v20c0 2.8 2.2 5 5 5h20c2.8 0 5-2.2 5-5v-20c0-2.8-2.2-5-5-5z m-10 10c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5z m6.3-3.3c0-1.2 1-2 2-2s2 1 2 2-0.8 2-2 2-2-0.9-2-2z m3.7 20h-20c-1 0-1.7-0.7-1.7-1.7v-10h3.4c0 4.7 3.6 8.3 8.3 8.3s8.3-3.6 8.3-8.3h3.4v10c0 1-0.7 1.7-1.7 1.7z' })
        )
    );
};

exports.default = TiSocialInstagram;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-instagram.js
// module id = 2010
// module chunks = 0